import LocalStorage from "./LocalStorage";

type returnStatus = boolean;

const saveReturnsStatus = (key: string, value: boolean) =>
  LocalStorage.setJSONValue(key, { value });

const getStoredReturnsStatus = (key: string): returnStatus | undefined =>
  LocalStorage.getJSONValue(key)?.value === true;

const getShowReturnsFromUrl = (key: string): returnStatus | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key)?.toLowerCase() === "true";
};

export const isReturnsEnabled = (): returnStatus => {
  const showReturns =
    [
      getShowReturnsFromUrl("redirectJDPOXAllReturnsToggle"),
      getStoredReturnsStatus("showReturns"),
    ].find((status) => status) || false;
  saveReturnsStatus("showReturns", showReturns);
  return showReturns;
};

export const isCreateReturnsEnabled = (): returnStatus => {
  const showReturns =
    [
      getShowReturnsFromUrl("isCreateJDPOXReturnsEnabled"),
      getStoredReturnsStatus("showCreateReturns"),
    ].find((status) => status) || false;
  saveReturnsStatus("showCreateReturns", showReturns);
  return showReturns;
};

export const isUserAuthorizedToCreateReturn = (
  isRBACEnabled: boolean,
  isAuthorizedToCreateReturn: boolean | undefined
): boolean | undefined => {
  if (!isRBACEnabled) return isCreateReturnsEnabled();
  return isAuthorizedToCreateReturn;
};
